
// this file defines the RecognitionType enum used across the application
export enum RecognitionType {
    ShoutOut = "ShoutOut",
    PowerUp = "PowerUp",
}

export interface Recognition {
    senderId: number;
    senderName: string;
    receiverId: number;
    receiverName: string;
    message: string;
    createdAt: string; 
    type?: RecognitionType;
}